export default class ConsignmentService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  getAllConsigments(args) {
    return this.axiosIns.get(this.serviceConfig.consignments, { params: args });
  }

  cancelConsignment(id) {
    return this.axiosIns.post(`${this.serviceConfig.consignments}/${id}/cancel`);
  }

  getConsignmentDetails(id) {
    return this.axiosIns.get(`${this.serviceConfig.consignments}/${id}/details`);
  }

  saveConsignment(consignmentId, args) {
    return this.axiosIns.put(`${this.serviceConfig.consignments}/draft/${consignmentId}`, args);
  }

  uploadConsignmentDocuments(id, args) {
    return this.axiosIns.post(`${this.serviceConfig.consignments}/${id}/documents`, args);
  }

  createProformaInvoice(id, args) {
    return this.axiosIns.post(`${this.serviceConfig.consignments}/${id}/proforma`, args);
  }

  createCn22Document(id, args) {
    return this.axiosIns.post(`${this.serviceConfig.consignments}/${id}/cn22`, args);
  }

  createCn23Document(id, args) {
    return this.axiosIns.post(`${this.serviceConfig.consignments}/${id}/cn23`, args);
  }

  returnConsignment(id, args) {
    return this.axiosIns.post(`${this.serviceConfig.consignments}/${id}/return`, args);
  }

  recheckStatus(consignmentId) {
    return this.axiosIns.get(
      `${this.serviceConfig.consignments}/${consignmentId}/recheck-status?type=sync`
    );
  }

  updatePackageManually(consignmentId) {
    return this.axiosIns.get(
      `${this.serviceConfig.consignments}/${consignmentId}/start-update-package-manually?sync=1`
    );
  }

  startProcessManually(consignmentId) {
    return this.axiosIns.get(
      `${this.serviceConfig.consignments}/${consignmentId}/start-process-manually`
    );
  }

  makeItOfficial(consignmentId, formData) {
    return this.axiosIns.post(
      `${this.serviceConfig.consignments}/draft/${consignmentId}/start-process`,
      formData
    );
  }

  createConsignment(args) {
    return this.axiosIns.post(this.serviceConfig.consignments, args);
  }

  getInvoicesList(args) {
    return this.axiosIns.post(`${this.serviceConfig.billCalculations}/consignments`, args);
  }

  getConsigmentsFindShipments(trackingCode) {
    return this.axiosIns.get(
      `${this.serviceConfig.consignments}/find/trackingCode/${trackingCode}`
    );
  }

  getConsignmentByReferenceNo(referenceNo) {
    return this.axiosIns.get(`${this.serviceConfig.consignments}/find/reference_no/${referenceNo}`);
  }

  updateConsignmentDimensions(consignmentId, packageId, args) {
    return this.axiosIns.patch(
      `${this.serviceConfig.consignments}/${consignmentId}/package/${packageId}/package-size-verify`,
      args
    );
  }
}
